import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { useErrorStore } from 'store/useErrorStore'
import { useErrorBoundary } from 'react-error-boundary'
import { MESSAGES } from '../messages/messages'

const Error = () => {
    const { resetBoundary } = useErrorBoundary()
    const { errorMessage, handleBack = resetBoundary } = useErrorStore((state) => state)

    return (
        <Box
            role="alert"
            sx={{
                display: 'grid',
                gap: 6,
                maxWidth: { xs: 358, md: 520 },
                px: { xs: 4, md: 14 },
                py: { xs: 17, md: 15 }
            }}
        >
            <Box
                sx={{
                    color: { md: 'common.fordBlue.main' },
                    display: 'grid',
                    gap: { xs: 4, md: 8 }
                }}
            >
                <Typography
                    variant="smallHeadline2"
                    sx={{
                        typography: { xs: 'smallHeadline2', md: 'largeHeadline2' }
                    }}
                >
                    {MESSAGES.sorry}
                </Typography>
                <Typography
                    variant="smallHeadline2"
                    sx={{
                        typography: { xs: 'smallHeadline2', md: 'largeHeadline2' },
                        textTransform: 'capitalize'
                    }}
                >
                    {MESSAGES.error_heading}
                </Typography>
                <Typography variant="regularBody1">{errorMessage}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: { xs: 4, md: 8 }
                }}
            >
                <Button variant="outlined" disableRipple onClick={handleBack}>
                    {MESSAGES.back}
                </Button>
            </Box>
        </Box>
    )
}

export default Error
